import { FactDataModel } from './FactDataModel';

export default {
    getFactValue: function (model: FactDataModel, key: string): number {
        return model.facts[key] ?? 0;
    },

    getDimension: function (model: FactDataModel, name: string): { [name: string]: FactDataModel } {
        return model.dimensions[name] ?? {} as { [name: string]: FactDataModel };
    },

    getDimensionValue: function (model: FactDataModel, name: string, value: string): FactDataModel {
        return (model.dimensions[name] ?? {})[value] ?? {
            facts: {},
            dimensions: {}
        } as FactDataModel;
    }
}
